import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as UserDeleteActions from '../actions/user-delete.actions';
import {UsersService} from '../../../services/api/users/users.service';
import * as OrganizationsActions from '../../organizations/actions/organizations.actions';
import * as CurrentOrganizationActions from '../../organizations/actions/current-organization.actions';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {DeleteUserPayload} from '../../../services/api/users/user.model';


@Injectable()
export class UserDeleteEffects {

  // noinspection JSUnusedGlobalSymbols
  userDelete$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserDeleteActions.userDelete),
      concatMap((payload: { data: DeleteUserPayload }) =>
        this.usersService.deleteUser(payload.data.organizationId, payload.data.userId)
          .pipe(
            map(data => UserDeleteActions.userDeleteSuccess({data})),
            catchError(error => of(UserDeleteActions.userDeleteFailure({error})))
          )
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  userDeleteSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserDeleteActions.userDeleteSuccess),
      tap(() => this.snackBar.open('User successfully deleted', 'Success', {duration: 3000})),
      map(() => {
        if (this.router.url.includes('/organizations')) {
          return OrganizationsActions.loadOrganizations();
        } else {
          return CurrentOrganizationActions.loadCurrentOrganization();
        }
      })
    );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly usersService: UsersService,
    private readonly router: Router,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
